import React from 'react';

const Photos = () => {
    return (
        <div className="w-full h-full">
            <div className="p-4">
                <h1 className="text-2xl font-bold text-navy-700 mb-4">Photos</h1>
                <div className="bg-white rounded-lg shadow-md p-6">
                    <p className="text-gray-700">This is the Photos page content. You can customize this based on your requirements.</p>
                </div>
            </div>
        </div>
    );
};

export default Photos; 